<template>
  <main>
    <div class="py-4 container-fluid">
      <GridRow>
        <GridCol :size="12">
          <MetaSection title="Realisasi Kinerja KPI">
            <!-- <div class="text-right">
              <div class="d-flex flex-row gap-3">
                <argon-button :outline="true">Kembali</argon-button>
                <argon-button>Kirim</argon-button>
              </div>
            </div> -->
          </MetaSection>
        </GridCol>
        <GridCol :size="12">
          <!-- <cards title="Form Realisasi KPI" useFooter> -->
            <!-- <template v-slot:footer>
              <div class="text-right">
                <div class="d-flex flex-row-reverse gap-2">
                  <ArgonButton>Lanjutkan</ArgonButton>
                  <ArgonButton :to="{ name: 'Realisasi Target' }" isRouteLink outline>Batalkan</ArgonButton>
                </div>
              </div>
            </template> -->

          <cards title="Form Realisasi KPI" :p="0" class="card--tabs">
            <tabbed-pane
              :tabs="tabs"
              :disabled="true"
            >
              <div class="tab-pane fade show active p-4 pt-0" id="pills-periode-penilaian" role="tabpanel"
                aria-labelledby="pills-periode-penilaian-tab">
                <FieldsetComponent title="Periode Penilaian"
                  description="Pastikan periode penilaian diisi sesuai dengan periode yang Anda laporkan">
                  <div class="flex flex-col gap-5">
                    <form-group label="Periode">
                      <select
                        class="form-select"
                        v-model="periode_id"
                        @change="choosePeriode()"
                      >
                        <option value="">Pilih periode penilaian</option>
                        <option v-for="(item, index) in list_periode" :key="index" :value="item.id">{{ item.name }}</option>
                      </select>
                    </form-group>

                    <form-group label="Jenis Penilaian">
                      <span class="form-control">{{ periode_selected?.type || '-' }}</span>
                    </form-group>

                    <form-group label="Tahun Penilaian">
                      <span class="form-control">{{ periode_selected?.year || '-' }}</span>
                    </form-group>
                  </div>
                </FieldsetComponent>
              </div>

              <div class="tab-pane fade show p-4 pt-0" id="pills-penilaian-kinerja" role="tabpanel"
                aria-labelledby="pills-penilaian-kinerja-tab">
                <FieldsetComponent
                  title="Penilaian Kinerja"
                  >
                  <form-group v-for="(item, index) in list_kpi" :key="index" :label="item.title" :hint="'Total Bobot ' + sumBobotSubKpi(item?.child || [])">
                    <div class="table-responsive">
                      <table class="table align-middle border border-1 border-light">
                        <thead class="table-light">
                          <tr>
                            <th>Sub KPI</th>
                            <th>Target</th>
                            <th>Satuan</th>
                            <th>Bobot</th>
                            <th>Realisasi</th>
                            <th class="text-center">Pencapaian</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(item_child, i) in item.child"
                            :key="i"
                            class="border border-bottom-1 border-light"
                          >
                            <td>
                              <p>{{ item_child?.title || '-' }}</p>
                              <p v-if="this.list_kpi[index].child[i].catatan" class="text-xs"> {{ this.list_kpi[index].child[i].catatan || '' }}</p>
                              <button
                                class="btn btn-outline-secondary btn-xs"
                                data-bs-toggle="modal"
                                data-bs-target="#noteModal"
                                type="button"
                                @click="openNoteModal(true, index, i)"
                              >
                                Berikan Catatan
                              </button>
                            </td>
                            <td>
                              <p>
                                <span v-if="item_child?.satuan?.toLowerCase() === 'rupiah'">
                                  {{
                                    new Intl.NumberFormat('id-ID', {
                                      style: 'currency',
                                      currency: 'IDR',
                                      minimumFractionDigits: 0,
                                    }).format(item_child?.target || '0')
                                  }}
                                </span>
                                <span v-else>
                                  {{
                                    new Intl.NumberFormat('id-ID', {
                                      minimumFractionDigits: 0,
                                    }).format(item_child?.target || '0')
                                  }} 
                                  <span class="text-capitalize">{{ (item_child?.satuan?.toLowerCase() === 'persen' ? '%' : item_child?.satuan) || '-' }}</span>
                                </span>
                              </p>
                            </td>
                            <td>
                              <p class="text-capitalize">{{ getSatuan(item_child?.satuan) ?? "-" }}</p>
                            </td>
                            <td>
                              <p>{{ item_child?.bobot ?? "-" }}</p>
                            </td>
                            <td>
                              <form-group>
                                <div class="input-group" v-if="item_child?.satuan">
                                  <span class="input-group-text" v-if="['rupiah'].includes(item_child.satuan.toLowerCase())">
                                    <span v-if="item_child.satuan.toLowerCase() === 'rupiah'">Rp</span>
                                  </span>
                                  <input
                                    type="number"
                                    v-model="this.list_kpi[index].child[i].realisasi"
                                    class="form-control"
                                    min="0"
                                    :max="item_child.satuan.toLowerCase() === 'persen' ? '100' : ''"
                                  >
                                  <span class="input-group-text" v-if="['persen','pcs'].includes(item_child.satuan.toLowerCase())">
                                    <span v-if="item_child.satuan.toLowerCase() === 'persen'">%</span>
                                    <span v-if="item_child.satuan.toLowerCase() === 'pcs'">Pcs</span>
                                  </span>
                                </div>

                                <input
                                  v-else
                                  type="number"
                                  v-model="this.list_kpi[index].child[i].realisasi"
                                  class="form-control"
                                  min="0"
                                />
                              </form-group>
                            </td>
                            <td>
                              <p>{{
                                  item_child?.satuan ?
                                  (item_child?.satuan?.toLocaleLowerCase() === 'persen' ? 
                                    new Intl.NumberFormat('id-ID', {
                                      minimumFractionDigits: 0,
                                    }).format(item_child?.realisasi || '0') + '%'
                                  : 
                                    (isNaN(item_child?.realisasi / item_child?.target) ? '0' : (isFinite(item_child?.realisasi / item_child?.target * 100) ? (item_child?.realisasi / item_child?.target * 100).toFixed(2) : '0')) + '%'
                                  )
                                  : "-"
                                }}
                              </p>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </form-group>

                  <!-- Modal -->
                  <div class="modal fade" id="noteModal" tabindex="-1" aria-labelledby="noteModalLabel" aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered modal-md">
                      <form class="modal-content" @submit.prevent="submitNote">
                        <div class="modal-header">
                          <h5 class="modal-title" id="noteModalLabel">Berikan Catatan</h5>
                          <span class="p-1 cursor-pointer" data-bs-dismiss="modal" aria-label="Close" ref="closeModalNote">
                            <font-awesome-icon icon="fa-solid fa-times" />
                          </span>
                        </div>
                        <div class="modal-body">
                          <form-group label="Tulis catatan">
                              <!-- v-model="this.list_kpi[index_kpi].child[index_sub_kpi].catatan" -->
                            <input
                              v-model="edit_catatan"
                              ref="editModalNote"
                              type="text"
                              class="form-control w-100"
                              placeholder="Tulis catatan disini..."
                            >

                          </form-group>
                        </div>
                        <div class="modal-footer">
                          <!-- <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal">Batalkan</button> -->
                          <button type="submit" class="btn-action btn-action--primary w-100">Simpan</button>
                        </div>
                      </form>
                    </div>
                  </div>
                </FieldsetComponent>
              </div>

              <div class="tab-pane fade show  p-4 pt-0" id="pills-penugasan-khusus" role="tabpanel"
                aria-labelledby="pills-penugasan-khusus-tab">
                <FieldsetComponent title="Penugasan Khusus" description="Masukkan data penugasan sesuai yang diberikan oleh pimpinan atau manajemen di luar jobdesk. Penugasan dapat berupa task karena rangkap jabatan, inovasi, atau kreatifitas.">
                  <form @submit.prevent="addPenugasanKhusus()">
                    <form-group>
                      <input
                        v-model="input_penugasan_khusus"
                        type="text"
                        class="form-control"
                        placeholder="Tulis penugasan khusus"
                        required
                      >
                      <p>
                        <small>
                          Contoh, Mengikuti training dalam setiap bulan
                        </small>
                      </p>
                    </form-group>
                    <!-- <argon-button class="btn btn-outline-secondary"><font-awesome-icon icon="fa-solid fa-plus" /> Tambah</argon-button> -->
                    <button type="submit" class="btn-action btn-action--secondary btn-xs">
                      <font-awesome-icon icon="fa-solid fa-plus" /> 
                      Tambah
                    </button>
                  </form>

                  <template v-if="list_penugasan_khusus.length > 0">
                    <hr />
                    <table class="table">
                      <thead>
                        <tr>
                          <th scope="col">Penugasan</th>
                          <th scope="col" style="width: 10px;">Aksi</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(item, index) in list_penugasan_khusus"
                          :key="index"
                        >
                          <td class="pt-4">{{ item }}</td>
                          <td class="pt-4" width="10">
                            <button class="btn btn-xs btn-outline-secondary" @click="deletePenugasanKhusus()">Hapus</button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </template>
                </FieldsetComponent>
              </div>

              <!-- <div class="tab-pane fade show" id="pills-pengurangan" role="tabpanel"
                aria-labelledby="pills-pengurangan-tab">
                <FieldsetComponent
                  title="Pengurangan"
                  description="Masukkan jumlah sanksi/pengurangan yang diterima dalam satu periode penilaian KPI."
                >
                  <form-group>
                    <div class="table-responsive">
                      <table class="table align-middle border border-1 border-light">
                        <thead class="table-light">
                          <tr>
                            <th>Tingkat Permasalahan</th>
                            <th>Jumlah</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(item, index) in list_pengurangan" :key="index" class="border border-bottom-1 border-light">
                            <td>{{ item?.tingkat_permasalahan ?? "-" }}</td>
                            <td>
                              <form-group>
                                <input
                                  v-model="this.list_pengurangan[index].jumlah_permasalahan"
                                  type="number"
                                  min="0"
                                  class="form-control"
                                />
                              </form-group>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </form-group>
                </FieldsetComponent>
              </div> -->

              <div class="tab-pane fade show p-4 pt-0" id="pills-ringkasan" role="tabpanel"
                aria-labelledby="pills-ringkasan-tab">
                <div class="row">
                  <div class="col-md-12 mb-4">
                    <h5>Ringkasan</h5>
                  </div>
                  <div class="col-md-12">
                    <form-group label="Periode">
                      <div class="table-responsive">
                        <table class="table align-middle">
                          <thead>
                            <tr>
                              <th>Periode</th>
                              <th>Jenis Penilaian</th>
                              <th>Tahun Penilaian</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>
                                {{ periode_selected?.name || '-' }}
                              </td>
                              <td>
                                {{ periode_selected?.type || '-' }}
                              </td>
                              <td>
                                {{ periode_selected?.year || '-' }}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </form-group>

                    <form-group label="Penilaian Kinerja">
                      <form-group v-for="(item, index) in list_kpi" :key="index" :label="item.title" :hint="sumBobotSubKpi(item?.child || [])">
                      <div class="table-responsive">
                        <table class="table align-middle border border-1 border-light">
                          <thead class="table-light">
                            <tr>
                              <th>Sub KPI</th>
                              <th>Target</th>
                              <th>Satuan</th>
                              <th>Bobot</th>
                              <th>Realisasi</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="(item_child, i) in item.child"
                              :key="i"
                              class="border border-bottom-1 border-light"
                            >
                              <td>
                                <p>{{ item_child?.title || '-' }}</p>
                                <p v-if="this.list_kpi[index].child[i].catatan" class="text-xs"> {{ this.list_kpi[index].child[i].catatan || '' }}</p>
                              </td>
                              <td>
                                <p>
                                  <span v-if="item_child?.satuan?.toLowerCase() === 'rupiah'">
                                    {{
                                      new Intl.NumberFormat('id-ID', {
                                        style: 'currency',
                                        currency: 'IDR',
                                        minimumFractionDigits: 0,
                                      }).format(item_child?.target || '0')
                                    }}
                                  </span>
                                  <span v-else>
                                    {{
                                      new Intl.NumberFormat('id-ID', {
                                        minimumFractionDigits: 0,
                                      }).format(item_child?.target || '0')
                                    }} 
                                    <span class="text-capitalize">{{ (item_child?.satuan?.toLowerCase() === 'persen' ? '%' : item_child?.satuan) || '-' }}</span>
                                  </span>
                                </p>
                              </td>
                              <td>
                                <p class="text-capitalize">{{ getSatuan(item_child?.satuan) ?? "-" }}</p>
                              </td>
                              <td>
                                <p>{{ item_child?.bobot ?? "-" }}</p>
                              </td>
                              <td>
                                <p>
                                  <span v-if="item_child?.satuan.toLowerCase() === 'rupiah'">
                                    {{
                                      new Intl.NumberFormat('id-ID', {
                                        style: 'currency',
                                        currency: 'IDR',
                                        minimumFractionDigits: 0,
                                      }).format(item_child?.realisasi || '0')
                                    }}
                                  </span>
                                  <span v-else>
                                    {{
                                      new Intl.NumberFormat('id-ID', {
                                        minimumFractionDigits: 0,
                                      }).format(item_child?.realisasi || '0')
                                    }} {{ item_child?.satuan.toLowerCase() === 'persen' ? '%' : (item_child?.satuan.toLowerCase() === 'pcs' ? 'Pcs' : '') }}
                                  </span>
                                </p>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </form-group>
                    </form-group>

                    <div class="mt-5 mb-5" v-if="list_penugasan_khusus.length > 0">
                      <h6>Penugasan Khusus</h6>

                      <template v-if="list_penugasan_khusus.length > 0">
                        <p
                          v-for="(item, index) in list_penugasan_khusus"
                          :key="index"
                        >
                          {{ item }}
                        </p>
                      </template>

                      <!-- <template v-if="list_penugasan_khusus.length > 0">
                        <hr />
                        <table class="table">
                          <tbody>
                            <tr
                              v-for="(item, index) in list_penugasan_khusus"
                              :key="index"
                            >
                              <td class="pt-4">{{ item }}</td>
                            </tr>
                          </tbody>
                        </table>
                      </template> -->
                    </div>

                    <!-- <form-group label="Pengurangan">
                      <div class="table-responsive">
                        <table class="table align-middle border border-1 border-light">
                          <thead class="table-light">
                            <tr>
                              <th>Tingkat Permasalahan</th>
                              <th width="160">Jumlah</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="(item, index) in list_pengurangan"
                              :key="index"
                              class="border border-bottom-1 border-light"
                            >
                              <td>{{ item?.tingkat_permasalahan || "-" }}</td>
                              <td>{{ item?.jumlah_permasalahan?.toString() || "-" }}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </form-group> -->
                  </div>
                </div>
                <!-- <FieldsetComponent title="Ringkasan">                  
                </FieldsetComponent> -->
              </div>
            </tabbed-pane>
            
            <hr />

            <div class="mt-4 d-flex justify-content-end gap-4">
              <button type="button" class="btn-action btn-action--secondary" v-if="step !== 0" @click="nextStep((step - 1), true)">Kembali</button>
              <button type="button" class="btn-action btn-action--primary" v-if="step < 3" @click="nextStep()">Lanjutkan</button>
              <button type="button" class="btn btn-action--primary" v-if="step === 3" @click="submit()">Simpan</button>
            </div>
          </cards>
        </GridCol>
      </GridRow>
    </div>
  </main>
</template>
    
<script>
import Cards from "@/components/CardComponent.vue";
import FormGroup from "@/components/FormGroup.vue";
// import EmployeeApi from "@/repository/api/EmployeeApi";
// import Select2 from 'vue3-select2-component';
import FieldsetComponent from "@/components/FieldsetComponent.vue";
import TabbedPane from "@/components/TabbedPane.vue";
// import ArgonButton from "@/components/ArgonButton.vue";
import MetaSection from '@/components/MetaSection.vue';
import GridRow from "@/components/grid/GridRow.vue";
import GridCol from "@/components/grid/GridCol.vue";
import PenguranganApi from "../../../repository/api/PenguranganApi";
// import InputForm from "@/components/InputForm.vue";

import KpiPeriodeApi from "@/repository/api/KpiPeriodeApi";
import KpiRealisasiApi from "@/repository/api/KpiRealisasiApi";

export default {
  name: "realisasi-target",
  components: {
    FieldsetComponent,
    Cards,
    FormGroup,
    TabbedPane,
    // ArgonButton,
    MetaSection,
    GridRow,
    GridCol,
    // InputForm,
  },
  data() {
    return {
      tabs: {
        'Periode Penilaian':true,
        'Penilaian Kinerja':false,
        'Penugasan Khusus':false,
        // 'Pengurangan':false,
        'Ringkasan':false
      },
      step: 0,

      employee_id: '', // data form

      list_periode: [],
      periode_id: '', // data form
      periode_selected: null,
      
      realization_id: null, // data form

      list_kpi: [], // data form
      index_kpi: null,
      index_sub_kpi: null,
      edit_catatan: '',

      list_penugasan_khusus: [], // data form
      input_penugasan_khusus: '',

      list_pengurangan: [], // data form
      satuan_target: [
        {
          value: 'rupiah',
          label: 'Rupiah'        
        },
        {
          value: 'persen',
          label: 'Persen/Hari/Skala Nilai'        
        },
        {
          value: 'pcs',
          label: 'Pcs'        
        }
      ],
    };
  },
  methods: {
    sumBobotSubKpi(data) {
      data = data.map((item) => Number.parseFloat(item?.bobot || 0));
      data = data.reduce((a, b) => a + b, 0);
      return data;
    },
    async nextStep(step=null, is_back=false) {
      if (step || step === 0) {
        this.step = step;
      } else {
        this.step += 1;
      }
      
      if (this.step === 1 && !is_back) {
        if (this.periode_id === '') {
          this.step = 0;
          this.$swal({
            icon: "warning",
            title: 'Periode penilaian perlu dipilih terlebih dahulu!',
          });
          return;
        }

        // check realisasi periode
        this.$store.state.loading = true;
        const result_check_periode = await KpiRealisasiApi.checkRealisasiKpi({
          employee_id: this.employee_id,
          periode_id: this.periode_id,
        }).then((resp) => {
          console.log(resp)
          return true;

        }).catch((err) => {
          console.log(err)
          return false;
        });
        this.$store.state.loading = false;

        if (!result_check_periode) {
          this.step = 0;
          this.$swal({
            icon: "warning",
            title: 'KPI sudah ada pada periode ini!',
          });
          return;
        }

        if (this.employee_id === '') {
          this.step = 0;
          this.$swal({
            icon: "warning",
            title: 'Data pegawai tidak ditemukan!',
          });
          return;
        }

        if (this.list_kpi.length === 0) {
          this.$store.state.loading = true;
          
          await KpiRealisasiApi.getbyparam({
            employee: this.employee_id,
            periode_id: this.periode_id,
          }).then((resp) => {
            console.log(resp)

            if (resp?.data && resp?.data?.length > 0) {
              for (let i = 0; i < resp.data.length; i++) {
                const item = resp.data[i];
                
                this.list_kpi.push({
                  title: item.title,
                  child: item.child.map(v => {
                    let data = {
                      kpiaspekpenilaianassignment_id: v.kpiaspekpenilaianassignment_id,
                      kpisub_id: v.id,
                      title: v.title,
                      bobot: v.bobot,
                      target: v.target,
                      satuan: v.satuan,
                      realisasi: 0,
                      catatan: '',
                    };

                    return data;
                  }),
                });
              }
            }
          }).catch((err) => {
            console.log(err)
          });

          this.$store.state.loading = false;
        }
      }

      // check penugasan - step 2
      // if (this.step === 3 && !is_back) {
      //   if (this.list_penugasan_khusus.length === 0) {
      //     this.step = 2;
      //     this.$swal({
      //       icon: "warning",
      //       title: 'Penugasan khusus harus diisi!',
      //     });
      //     return;
      //   }
      // }
      
      const nav_tab = document.getElementsByClassName('nav-link-tab');
      const tab_pane = document.getElementsByClassName('tab-pane');

      for (let index = 0; index < nav_tab.length; index++) {
        nav_tab[index].classList.remove('active');
      }

      for (let index = 0; index < tab_pane.length; index++) {
        tab_pane[index].classList.remove('active');
      }

      Object.keys(this.tabs).forEach(async (item, index) => {
        if (index === this.step) {
          nav_tab[index].classList.add('active');
          tab_pane[index].classList.add('active');
        }
      });
    },
    openNoteModal(is_open=false, index_kpi=null, index_sub_kpi=null) {

      this.index_kpi = index_kpi;
      this.index_sub_kpi = index_sub_kpi;

      if (is_open) {
        this.edit_catatan = this.list_kpi[this.index_kpi].child[this.index_sub_kpi].catatan;
        setTimeout(() => {
          this.$refs.editModalNote.focus();
        }, 600);
      }
    },

    submitNote() {
      this.list_kpi[this.index_kpi].child[this.index_sub_kpi].catatan = this.edit_catatan;
      this.edit_catatan = '';
      this.$refs.closeModalNote.click()
    },

    addPenugasanKhusus() {
      this.list_penugasan_khusus.push(this.input_penugasan_khusus);
      this.input_penugasan_khusus = '';
    },

    deletePenugasanKhusus(index) {
      this.list_penugasan_khusus.splice(index, 1);
    },

    async submit() {

      // step 1
      // employee_id: '', // data form
      // periode_id: '', // data form

      // step 2
      // employee_id: '', // data form
      // realization_id: null, // data form
      // list_kpi: [], // data form

      // step 3 -> each data list_penugasan_khusus
      // employee_id: '', // data form
      // realization_id: null, // data form
      // list_penugasan_khusus: [], // data form

      // step 4
      // employee_id: '', // data form
      // realization_id: null, // data form
      // list_pengurangan: [], // data form

      // console.log('this.employee_id', this.employee_id)
      // console.log('this.periode_id', this.periode_id)
      // console.log('this.realization_id', this.realization_id)
      // console.log('this.list_kpi', this.list_kpi)
      // console.log('this.list_penugasan_khusus', this.list_penugasan_khusus)
      // console.log('this.list_pengurangan', this.list_pengurangan)

      this.$swal({
        icon: "info",
        title: "Submit Realisasi Kinerja KPI?",
        showCancelButton: true,
      }).then(async (result) => {
        if (result.isConfirmed) {
          this.$store.state.loading = true;

          try {

            // step 1
            await KpiRealisasiApi.addRealisasiKpi({
              periode: this.periode_id,
              employee: this.employee_id,
            })
              .then((resp) => {
                console.log('addRealisasiKpi()')
                console.log(resp?.data)
                this.realization_id = resp?.data?.id;
              }).catch((error) => {
                console.log(error)
                // this.$swal({
                //   icon: "error",
                //   title: error?.response?.data?.message,
                // });
                throw error;
              });
            
            // step 2
            let realisasi = [];

            this.list_kpi.forEach(item => {
              if (item?.child) {
                item.child.forEach(item_child => {
                  realisasi.push({
                    kpiaspekpenilaianassignment_id: item_child.kpiaspekpenilaianassignment_id,
                    kpisub_id: item_child.kpisub_id,
                    bobot: item_child.bobot,
                    target: item_child.target,
                    realisasi: item_child.realisasi,
                    catatan: item_child.catatan,
                    satuan: item_child.satuan,
                  })
                });
              }
            });
            
            await KpiRealisasiApi.addRealisasiKinerja({
              employee_id: this.employee_id,
              realization_id: this.realization_id,
              realisasi: JSON.stringify(realisasi),
            })
              .then((resp) => {
                console.log('addRealisasiKinerja()')
                console.log(resp?.data)
              }).catch((error) => {
                console.log(error)
                // this.$swal({
                //   icon: "error",
                //   title: error?.response?.data?.message,
                // });
                throw error;
              });
            
            // step 3
            for (let i = 0; i < this.list_penugasan_khusus.length; i++) {
              const item = this.list_penugasan_khusus[i];

              await KpiRealisasiApi.addRealisasiPenugasanKhusus({
                employee_id: this.employee_id,
                realization_id: this.realization_id,
                name: item,
              })
                .then((resp) => {
                  console.log('addRealisasiPenugasanKhusus() '+ i)
                  console.log(resp?.data)
                }).catch((error) => {
                  console.log(error)
                  // this.$swal({
                  //   icon: "error",
                  //   title: error?.response?.data?.message,
                  // });
                  throw error;
                });
            }

            // step 4
            // let pengurangan = this.list_pengurangan;
            
            // await KpiRealisasiApi.addRealisasiPengurangan({
            //   employee_id: this.employee_id,
            //   realization_id: this.realization_id,
            //   pengurangan: JSON.stringify(pengurangan),
            // })
            //   .then((resp) => {
            //     console.log('addRealisasiPengurangan()')
            //     console.log(resp?.data)
            //   }).catch((error) => {
            //     // console.log(error)
            //     // this.$swal({
            //     //   icon: "error",
            //     //   title: error?.response?.data?.message,
            //     // });
            //     throw error;
            //   });
            

            // success -> reset all data

            // this.step = 0;
            this.nextStep(0, true);

            // this.employee_id = ''; // data form

            // this.list_periode = [];
            this.periode_id = ''; // data form
            this.periode_selected = null;
            
            this.realization_id = null; // data form

            this.list_kpi = []; // data form
            this.index_kpi = null;
            this.index_sub_kpi = null;
            this.edit_catatan = '';

            this.list_penugasan_khusus = []; // data form
            this.input_penugasan_khusus = '';

            this.list_pengurangan = []; // data form
            // await this.getMasterPengurangan()
            //   .then(() => {})
            //   .catch((err) => {
            //     throw err;
            //   });
            // end reset data

            this.$store.state.loading = false;

            this.$swal({
              icon: "success",
              title: 'Berhasil menambahkan realisasi KPI.',
            });
            
          } catch (error) {
            console.log(error)
            // this.$store.state.loading = false;
            this.$swal({
              icon: "error",
              title: error?.response?.data?.message || 'Something wrong, please try again.',
            });
          }
        }
      });
    },
    async getData() {
      // await EmployeeApi.get(this.$route.params.id).then((response) => {
      //   this.data = response.data;
      // }).catch((error) => {
      //   this.$swal({
      //     icon: "error",
      //     title: error.response.data.message,
      //   }).then(() => {
      //     this.$router.push({ name: "Dashboard" });
      //   });
      // })
    },
    async getKpiPeriode() {
      await KpiPeriodeApi.getbyparam({
        status: 'active',
        limit: 100,
      })
        .then((response) => {
          this.list_periode = response?.data || [];
        })
        .catch((err) => {
          console.log(err)
        });
    },
    choosePeriode() {
      // console.log(this.periode_id)
      this.list_kpi = [];

      const filter_periode = this.list_periode.filter((item) => item.id === this.periode_id);

      if (filter_periode && filter_periode?.[0]) {
        this.periode_selected = filter_periode[0];
      } else {
        this.periode_selected = null;
      }
    },
    async getMasterPengurangan() {
      await PenguranganApi.get()
        .then((resp) => {
          if (resp?.data) {
            for (let i = 0; i < resp.data.length; i++) {
              const item = resp.data[i];
              
              this.list_pengurangan.push({
                id: item.id,
                tingkat_permasalahan: item.tingkat_permasalahan,
                nilai: item.nilai,
                jumlah_permasalahan: 0,
              })
            }
          }
        })
        .catch((err) => {
          console.log(err)
        });
    },
    getSatuan(satuan) {
      let result = null
      try {
        result = this.satuan_target.find(({ value }) => value === satuan);
        result = result.label
      } catch (error) {
        result = satuan
      }
      return result
    }
  },
  async mounted() {
    this.$store.state.loading = true;
    await this.getSessionUser();
    await this.getKpiPeriode();
    // await this.getMasterPengurangan();
    this.$store.state.loading = false;

    this.employee_id = this.$store.state?.sessionUser?.employee?.id || '';
  },
};
</script>
    